import '../App.css';
import image from '../Images/image1.png';  
import {useState,useEffect} from 'react';   
import Loader from '../Loader';
import Header from '../Header';
import { PageType } from '../Constants';
function Codeforces(){
         const [data,setData]=useState(null);
         const [img,Setimg]=useState(image); 
         useEffect(()=>{
            fetch('https://kontests.net/api/v1/codeforces').then((data)=>{return data.json()}).then((response)=>{  
                   setData(response);  
            });
         },[]);
         useEffect(()=>{
             window.scrollTo(0,0);
         },[]);
    return (
        <>
        {data==null ? <Loader/> : null}
        {data != null && <>
        <Header Pagetype={PageType.CONTEST_PAGE} Title={"CodeForces Contests"}/>
        {data.map((Data)=>
        <div className="card"> 
             <div className="img-div">
                  <img className="img" src={img} title="Codeforces"></img>  
             </div>
             <div className="divbody">   
                  <p className="card-title">{Data.name}</p>  
                  <a href={Data.url} target="_blank"><button className="btn">Enter</button></a>  
             </div>
        </div> 
        )}
        </>
      }
     </>  
    );
}
export default Codeforces;